import { Component, OnInit, Inject, ViewChild, Optional, OnDestroy, HostListener, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioButton } from '@angular/material/radio';
import { MatCheckbox } from '@angular/material/checkbox';
import { Subject } from 'rxjs';
import { saveAs } from 'file-saver';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { CookieService } from 'ngx-cookie-service';
import { LoggingService } from '@EfsServices/logging.service';
import { DataSharingService } from '../shared/services/data-sharing.service';
import { EfsApiService } from '@EfsServices/efs-api.service';
import { environment } from '@efsEnvironments/environment';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { ApiErrorHandlingService } from '@EfsServices/api-error-handling.service';
import { SessionTimerService } from '@EfsServices/session-timer.service';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';

@Component({
  selector: 'app-perf-measurements',
  templateUrl: './perf-measurements.component.html',
  styleUrl: './perf-measurements.component.css',
  standalone: false,
})
export class PerfMeasurementsComponent {

  writeMode = false;

  perfMeasurementsFieldTitle = 'Add Perf Measurements';
  perfMeasurementId: number = 0;

  showAddPerfmeasurementsButton = true;
  showModifyPerfmeasurementsButton = false;
  showAddNewPerfmeasurementsButton = false;

  addPerfMeasurementsDisable = true;
  modifyPerfMeasurementsDisable = true;

  recipeNumControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*\.?[0-9]+$'),
    Validators.required,
  ]);
  noOfInsertsControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*\.?[0-9]+$'),
  ]);
  horzPerf1Control = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*\.?[0-9]+$'),
  ]);
  horzPerf2Control = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*\.?[0-9]+$'),
  ]);
  horzPerf3Control = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*\.?[0-9]+$'),
  ]);
  horzPerf4Control = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*\.?[0-9]+$'),
  ]);
  vertPerf1Control = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*\.?[0-9]+$'),
  ]);
  vertPerf2Control = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]*\.?[0-9]+$'),
  ]);
  commentsControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('[a-zA-Z0-9\\"\'\\-./\\s]+'),

  ]);
  // foldDiameterParameterControl = new UntypedFormControl({ value: '', disabled: false }, [
  //   Validators.pattern('[0-9\\-/\\s]+'),
  //   Validators.required,
  // ]);


  tableRowData: any;

  tableData: any[] = [];

  public tableEventSubject: Subject<any> = new Subject<any>();
  columns = [

    {
      columnDef: 'recipeNum', header: 'Recipe Number',
      cell: (element: any) => `${element.recipeNum ?? ''}`
    },
    {
      columnDef: 'noOfInserts', header: 'Number of Inserts',
      cell: (element: any) => `${element.noOfInserts ?? ''}`
    },
    {
      columnDef: 'horzPerf1', header: 'Horizontal Perf 1',
      cell: (element: any) => `${element.horzPerf1 ?? ''}`
    },
    {
      columnDef: 'horzPerf2', header: 'Horizontal Perf 2',
      cell: (element: any) => `${element.horzPerf2 ?? ''}`
    },
    {
      columnDef: 'horzPerf3', header: 'Horizontal Perf 3',
      cell: (element: any) => `${element.horzPerf3 ?? ''}`
    },
    {
      columnDef: 'horzPerf4', header: 'Horizontal Perf 4',
      cell: (element: any) => `${element.horzPerf4 ?? ''}`
    },
    {
      columnDef: 'vertPerf1', header: 'Vertical Perf 1',
      cell: (element: any) => `${element.vertPerf1 ?? ''}`
    },
    {
      columnDef: 'vertPerf2', header: 'Vertical Perf 2',
      cell: (element: any) => `${element.vertPerf2 ?? ''}`
    },
    {
      columnDef: 'comments', header: 'Comments',
      cell: (element: any) => `${element.comments}`
    },
  ];

  displayedColumns = this.columns.map(c => c.columnDef);

  constructor(
    public permissionHandlingService: PermissionHandlingService,
    private efsApiService: EfsApiService,
    private router: Router,
    private route: ActivatedRoute,
    public dataSharingService: DataSharingService,
    public dialog: MatDialog,
    public loggingService: LoggingService,
    private apiErrorHandlingService: ApiErrorHandlingService,
  ) { }

  ngOnInit() {

    if (this.permissionHandlingService.permissionsMap.get('EFS-PROD METHOD GROUP WRITE')) {
      this.writeMode = true;
    } else {
      this.writeMode = false;
    }

    this.getPerfMeasurementsService();
    this.checkForInvalidInput();

  }

  // services

  getPerfMeasurementsService() {
    this.efsApiService.getPerfMeasurements().subscribe({
      next: (response: any) => {
        this.tableData = response;
        this.tableEventSubject.next(response);
      },
      error: (error) => {
        this.apiErrorHandlingService.errorStatusHandler(error);
      }
    });
  }

  addPerfMeasurementsService(perfMeasurementsBody) {
    this.efsApiService.addPerfMeasurement(perfMeasurementsBody).subscribe({
      next: (response) => {
        console.log(response);
        this.popupWarning(false, 'Successfully added New Performance Measurements');
        this.addPerfMeasurementsDisable = false;
        // refresh table data
        this.getPerfMeasurementsService();
        // reset the fields
        this.addNewPerfMeasurementButton();

      },
      error: (error) => {
        this.addPerfMeasurementsDisable = false;
        this.apiErrorHandlingService.errorStatusHandler(error);
      }
    });
  }

  modifyPerfMeasurementsService(perfMeasurementsBody) {
    this.efsApiService.updatePerfMeasurement(perfMeasurementsBody).subscribe({
      next: (response) => {
        console.log(response);
        this.popupWarning(false, 'Successfully modified Performance Measurements');
        this.modifyPerfMeasurementsDisable = false;
        // refresh table data
        this.getPerfMeasurementsService();
        // reset the fields
        this.addNewPerfMeasurementButton();
      },
      error: (error) => {
        this.modifyPerfMeasurementsDisable = false;
        this.apiErrorHandlingService.errorStatusHandler(error);
      }
    });
  }

  // end of services

  // functions

  addPerfMeasurementsButton() {
    // disable button against double submit
    this.addPerfMeasurementsDisable = true;
    const perfMeasurementsBody = {
      recipeNum: this.recipeNumControl.value,
      noOfInserts: this.noOfInsertsControl.value,
      horzPerf1: this.horzPerf1Control.value,
      horzPerf2: this.horzPerf2Control.value,
      horzPerf3: this.horzPerf3Control.value,
      horzPerf4: this.horzPerf4Control.value,
      vertPerf1: this.vertPerf1Control.value,
      vertPerf2: this.vertPerf2Control.value,
      comments: this.commentsControl.value,
    };

    // check for duplciate recipe number
    for (const item of this.tableData) {
      if (item.recipeNum === perfMeasurementsBody.recipeNum) {
        this.popupWarning(false, 'Recipe Number already exists, please use a different Recipe Number.');
        return;
      }
    }

    this.addPerfMeasurementsService(perfMeasurementsBody);

  }

  checkForInvalidInput() {

    // disable buttons if invalid inputs, must check on every field
    this.recipeNumControl.valueChanges.subscribe((input) => {
      this.addButtonDisableToggle();
    });
    this.noOfInsertsControl.valueChanges.subscribe((input) => {
      this.addButtonDisableToggle();
    });
    this.horzPerf1Control.valueChanges.subscribe((input) => {
      this.addButtonDisableToggle();
    });
    this.horzPerf2Control.valueChanges.subscribe((input) => {
      this.addButtonDisableToggle();
    });
    this.horzPerf3Control.valueChanges.subscribe((input) => {
      this.addButtonDisableToggle();
    });
    this.horzPerf4Control.valueChanges.subscribe((input) => {
      this.addButtonDisableToggle();
    });
    this.vertPerf1Control.valueChanges.subscribe((input) => {
      this.addButtonDisableToggle();
    });
    this.vertPerf2Control.valueChanges.subscribe((input) => {
      this.addButtonDisableToggle();
    });
    this.commentsControl.valueChanges.subscribe((input) => {
      this.addButtonDisableToggle();
    });
  }

  // controls the toggle of the add button
  addButtonDisableToggle() {
    // console.log(this.recipeNumControl.status);
    // console.log(this.noOfInsertsControl.status);
    // console.log(this.horzPerf1Control.status);
    // console.log(this.horzPerf2Control.status);
    // console.log(this.horzPerf3Control.status);
    // console.log(this.horzPerf4Control.status);
    // console.log(this.vertPerf1Control.status);
    // console.log(this.vertPerf2Control.status);
    // console.log(this.commentsControl.status);

    if (this.recipeNumControl.status === 'INVALID' ||
      this.noOfInsertsControl.status === 'INVALID' ||
      this.horzPerf1Control.status === 'INVALID' ||
      this.horzPerf2Control.status === 'INVALID' ||
      this.horzPerf3Control.status === 'INVALID' ||
      this.horzPerf4Control.status === 'INVALID' ||
      this.vertPerf1Control.status === 'INVALID' ||
      this.vertPerf2Control.status === 'INVALID' ||
      this.commentsControl.status === 'INVALID') {
      this.addPerfMeasurementsDisable = true;
      this.modifyPerfMeasurementsDisable = true;
    } else {
      this.addPerfMeasurementsDisable = false;
      this.modifyPerfMeasurementsDisable = false;
    }
  }

  modifyPerfMeasurementsButton() {
    // disable button against double submit
    this.modifyPerfMeasurementsDisable = true;
    const perfMeasurementsBody = {
      perfMeasurementId: this.tableRowData.perfMeasurementId,
      recipeNum: this.recipeNumControl.value,
      noOfInserts: this.noOfInsertsControl.value,
      horzPerf1: this.horzPerf1Control.value,
      horzPerf2: this.horzPerf2Control.value,
      horzPerf3: this.horzPerf3Control.value,
      horzPerf4: this.horzPerf4Control.value,
      vertPerf1: this.vertPerf1Control.value,
      vertPerf2: this.vertPerf2Control.value,
      comments: this.commentsControl.value,
    };

    

    this.modifyPerfMeasurementsService(perfMeasurementsBody);

  }

  addNewPerfMeasurementButton() {
    // reset form for adding new perf measurement
    this.perfMeasurementsFieldTitle = 'Add Perf Measurements';
    this.showAddPerfmeasurementsButton = true;
    this.showModifyPerfmeasurementsButton = false;
    this.showAddNewPerfmeasurementsButton = false;

    this.perfMeasurementId = null;

    // enable the recipe num control field
    this.recipeNumControl.enable();

    this.recipeNumControl.reset();
    this.noOfInsertsControl.reset();
    this.horzPerf1Control.reset();
    this.horzPerf2Control.reset();
    this.horzPerf3Control.reset();
    this.horzPerf4Control.reset();
    this.vertPerf1Control.reset();
    this.vertPerf2Control.reset();
    this.commentsControl.reset();
  }

  exportTableButton() {
    // make new json with flattened selected values
    const copyItems = [];

    let items = [];
    items = this.tableData;

    for (const item of items) {
      const tempObj = {
        recipeNum: '',
        noOfPerfs: '',
        horzPerf1: '',
        horzPerf2: '',
        horzPerf3: '',
        horzPerf4: '',
        vertPerf1: '',
        vertPerf2: '',
        comments: '',
      };
      tempObj.recipeNum = item.recipeNum;
      tempObj.noOfPerfs = item.noOfInserts;
      tempObj.horzPerf1 = item.horzPerf1;
      tempObj.horzPerf2 = item.horzPerf2;
      tempObj.horzPerf3 = item.horzPerf3;
      tempObj.horzPerf4 = item.horzPerf4;
      tempObj.vertPerf1 = item.vertPerf1;
      tempObj.vertPerf2 = item.vertPerf2;
      tempObj.comments = item.comments;

      copyItems.push(tempObj);
    }
    // copyItems.unshift('sep=,');
    console.log(JSON.stringify(copyItems));

    // convert json to csv
    const replacer = (key, value) => value === null ? '' : value;
    const header = Object.keys(copyItems[0]);
    const csv = copyItems.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    // csv.unshift('sep=,');
    let finalCsv = JSON.stringify(csv);
    finalCsv = csv.join('\r\n');
    console.log(finalCsv);
    finalCsv = finalCsv.replace(/\\"/g, '""');
    const csvFile = finalCsv;
    console.log(finalCsv);

    const blob = new Blob([csvFile], { type: 'text/csv' });
    saveAs(blob, 'perfMeasurementTable.csv');
  }


  onRowClick(rowData: any) {

    // Scroll to top of page
    window.scrollTo(0, 0);

    this.tableReceiveMessage(rowData);
    // change title and remove add button, show modify button and add new button
    this.perfMeasurementsFieldTitle = 'Modify Perf Measurements';
    this.showAddPerfmeasurementsButton = false;
    this.showModifyPerfmeasurementsButton = true;
    this.showAddNewPerfmeasurementsButton = true;

    // disable the recipe num control field
    this.recipeNumControl.disable();

    // set perf measurement id for display
    this.perfMeasurementId = rowData.perfMeasurementId;

    // enable modify section
    // disable add section
    // fill out modify section with data
    this.recipeNumControl.setValue(rowData.recipeNum);
    this.noOfInsertsControl.setValue(rowData.noOfInserts);
    this.horzPerf1Control.setValue(rowData.horzPerf1);
    this.horzPerf2Control.setValue(rowData.horzPerf2);
    this.horzPerf3Control.setValue(rowData.horzPerf3);
    this.horzPerf4Control.setValue(rowData.horzPerf4);
    this.vertPerf1Control.setValue(rowData.vertPerf1);
    this.vertPerf2Control.setValue(rowData.vertPerf2);
    this.commentsControl.setValue(rowData.comments);

    // touch the fields to trigger validation
    this.recipeNumControl.markAsTouched();
    this.noOfInsertsControl.markAsTouched();
    this.horzPerf1Control.markAsTouched();
    this.horzPerf2Control.markAsTouched();
    this.horzPerf3Control.markAsTouched();
    this.horzPerf4Control.markAsTouched();
    this.vertPerf1Control.markAsTouched();
    this.vertPerf2Control.markAsTouched();
    this.commentsControl.markAsTouched();
  }

  popupWarning(questionType, message) {
    const popupDialogRef = this.dialog.open(GenericPopupComponent, {
      width: '450px',
      height: '250px',
      panelClass: 'popup-borders',
      data: {
        questionType,
        title: 'Alert',
        message
      }
    });
    // return true;
  }

  tableReceiveMessage($event) {
    this.tableRowData = $event;
    console.log('I RECEIVED ' + JSON.stringify(this.tableRowData));

    // this.serviceGetPlanTemplateById(this.tableRowData.planTemplateId); // get full body data when searching by client
    // when user clicks get template details from service
    // this.serviceGetProdMethodGroupTemplateById(this.tableRowData.planTemplateId);
    // this.listCorpsButtonToggle();
    // this.modifyButtonToggle();
    // this.copyButtonToggle();
    // this.deleteButtonToggle();
  }

}
